// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__UTmfb","topBottomGutter":"Layout_topBottomGutter__87Zq4"};